import React from 'react';

const ReceptionConsumeButton = ({ onClick, className = '', variant = 'primary' }) => {
  const styles = variant === 'link'
    ? 'text-amber-700 hover:text-amber-900 font-medium'
    : 'px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors text-sm font-medium';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles} ${className}`.trim()}
      title="Consumir inventario de esta recepción"
    >
      Consumir
    </button>
  );
};

export default ReceptionConsumeButton;
